module.exports = __webpack_public_path__ + "img/Fietsmerin_A5_v2.d09dacb8.jpg";